import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AllReferralsComponent } from './all-referrals/all-referrals.component';
//import { FacebookModule } from 'ngx-facebook';
import { RouterModule } from '@angular/router'; 
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http'
import { MediaPerformanceDirective } from './media-performance.directive';

@NgModule({
  declarations: [
    AppComponent,
    AllReferralsComponent,
  ],
  imports: [
    AppRoutingModule,
    MediaPerformanceDirective,
    RouterModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {
}
